module.exports = __webpack_public_path__ + "static/img/81.10f4a22.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/81.png
// module id = F7O0
// module chunks = 0